import { NumericInputField, TextInputField } from '@cmg/common';
import { FormattedNumber } from '@cmg/i18n';
import isNil from 'lodash/isNil';
import React from 'react';

export type Props = {
  isEditing?: boolean;
  shares?: number | null;
};

const AllocationSharesField: React.FC<Props> = ({ isEditing, shares }) => {
  if (isEditing) {
    return <NumericInputField name="allocation.shares" fullWidth precision={0} />;
  }

  if (!isNil(shares)) {
    return (
      <span>
        <FormattedNumber value={shares} format="integer" />
      </span>
    );
  }

  return <TextInputField name="emptyShares" disabled placeholder="N/A" fullWidth />;
};

export default AllocationSharesField;
